<template>
  <div class="retail-side-pricing">
    <div class="toggle-button" v-if="userProfile.profession == 'Retail Investor'">
      <button :class="{ 'active-premium': activePlanType == 'Premium' }" class="toggle-option premium" @click="activePlanType = 'Premium'">
        Premium
        <img src="../../assets/images/ChatImages/Premium Icon active.svg" alt="" v-if="activePlanType == 'Premium'" />
        <img src="../../assets/images/ChatImages/Premium Icon.svg" alt="" v-else />
      </button>
      <button :class="{ 'active-chat': activePlanType == 'StockAnts Chat' }" class="toggle-option chat" @click="activePlanType = 'StockAnts Chat'">
        Chat
        <img src="../../assets/images/ChatImages/chatIconWhite.svg" alt="" v-if="activePlanType == 'StockAnts Chat'" />
        <img src="../../assets/images/ChatImages/chatIconGray.svg" alt="" v-else />
      </button>
    </div>
    <div v-if="activePlanType == 'StockAnts Chat'" class="chat-pricing-card">
      <div class="details-card">
        <div class="flex-center pricing-main-cards">
          <div class="special-card chat text-center">
            <div class="top-line"></div>
            <div class="inner-card">
              <p class="plan-title">StockAnts Chat</p>
              <div class="chat-card-section">
                <div class="inner-content">
                  <!-- Pricing Table with Radio Buttons -->

                  <!-- <div class="pricing-table">
                    <div class="flex-space-between table-titles">
                      <div>Select Plan</div>
                      <div>Validity</div>
                    </div>
                    <div
                      class="pricing-row"
                      v-for="(option, index) in chatPackages"
                      :key="index"
                      :class="{
                        'active-row': selectedPackage === option.label,
                      }"
                    >
                      <div class="pricing-column">
                        <el-radio v-model="selectedPackage" :label="option.label">
                          {{ option.label }}
                        </el-radio>
                      </div>
                      <div class="pricing-column price">
                        ₹ {{ option.price }}
                        <span style="font-size: 0.6rem; font-weight: 500">/ Chat</span>
                      </div>
                      <div class="pricing-column duration">{{ option.duration }} Days</div>
                    </div>
                  </div> -->

                  <img style="margin-top: 20px" src="../../assets/images/ChatImages/chatIconBlue.png" alt="" />

                  <p class="cost">
                    <span>
                      ₹ {{ selectedChatPackage.price }}/
                      <span class="chat-duration">15 Min</span>
                    </span>
                  </p>

<!-- <div class="chat-note">Prices may vary between off-market and During market hours.</div> -->
                  <!-- Subscribe Button -->
                  <div class="flex-center" v-if="!Object.keys(getChatPlanDetails).length">
                    <el-button type="primary" class="full-width-btn" :disabled="!selectedPackage || !acceptTerms" @click="getOrderId('Chat')" :loading="is_purchase_plan_in_progress">Chat Now</el-button>
                  </div>
                  <div class="flex-center" v-else>
                    <el-button type="primary" class="full-width-btn" disabled>Subscribed</el-button>
                  </div>

                  <!-- Terms and Conditions -->
                  <div class="agreement-checkbox" style="margin-top: 5px">
                    <el-checkbox v-model="acceptTerms"></el-checkbox>
                    <p>
                      I Accept
                      <router-link to="/retail-side/terms-condition" style="color: #2488ff">Terms and Conditions</router-link>
                      and
                      <a href="https://d3vvd51leqaoql.cloudfront.net/stockants_chat/chat_agreement.pdf" style="color: #2488ff">Chat Agreement</a>
                    </p>
                  </div>
                  <div class="chat-note text-left">Note: This subscription will be valid for 15 days.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="chat-details-card">
        <el-card class="chat-details-card-inner">
          <div class="drawer-content">
            <div class="inner-content">
              <h2 class="drawer-heading">“Connect with SEBI Expert Anytime Now”</h2>
              <!-- <p class="drawer-subtext">Unlock SEBI Expert Advice Anytime, Anywhere with</p> -->

              <div class="details-list">
                <div class="points">
                  <i class="el-icon-success"></i>
                  Exclusive 15 mins Session
                </div>
                <div class="points">
                  <i class="el-icon-success"></i>
                  Connect Instant with SEBI Experts
                </div>
                <div class="points">
                  <i class="el-icon-success"></i>
                  Real Time Guidance
                </div>
              </div>
            </div>
          </div>

          <div class="partition-line"></div>
          <div class="faq-section">
            <div class="text-center">
              <div class="faq-title">FAQs?</div>
            </div>

            <div class="card-container">
              <el-collapse v-model="activeCollapse">
                <el-collapse-item name="1">
                  <template slot="title">
                    <span class="el-collapse-item__header-text question">What is the StockAnts "expert chat" service?</span>
                  </template>
                  <span class="answer" style="color: black">The "expert chat" service allows users to chat with SEBI Experts to get financial advice, get knowledge regarding stocks or mutual funds, and receive fundamental and technical analysis.</span>
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template slot="title">
                    <span class="el-collapse-item__header-text question">Is there a free trial available?</span>
                  </template>
                  <span class="answer" style="color: black">The "expert chat" service allows users to chat with SEBI Experts to get financial advice, get knowledge regarding stocks or mutual funds, and receive fundamental and technical analysis.</span>
                </el-collapse-item>
                <el-collapse-item name="">
                  <template slot="title">
                    <span class="el-collapse-item__header-text question">How long are the available chat slots?</span>
                  </template>
                  <span class="answer" style="color: black">The "expert chat" service allows users to chat with SEBI Experts to get financial advice, get knowledge regarding stocks or mutual funds, and receive fundamental and technical analysis.</span>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <div v-else>
      <el-row v-loading="is_subscribed_plan_details_loading">
        <el-col :xs="1" :sm="1" :md="1" :lg="2" :xl="3">&nbsp;</el-col>
        <el-col :xs="22" :sm="22" :md="22" :lg="20" :xl="18">
          <div class="details-card">
            <div class="flex-center pricing-main-cards">
              <div class="special-card blue text-center">
                <div class="top-line"></div>
                <div class="inner-card">
                  <p class="plan-title">StockAnts Premium</p>
                  <img src="../../assets/images/RetailSideLandingPurple/Premium Icon blue.svg" alt="" />

                  <p class="cost" style="font-size: 1.2rem; font-weight: bold" v-if="planDetails && planDetails.promotional_plan">3 Days FREE Trial</p>
                  <p v-else class="cost">
                    <span>₹ {{ premium_pricing_Cost }}</span>
                  </p>
                  <el-checkbox-group v-model="selectedMarketOption" :min="2" @change="setPricing()" style="margin: 10px 0">
                    <el-checkbox label="Equity" style="margin-right: 10px"></el-checkbox>
                    <el-checkbox label="Options"></el-checkbox>
                  </el-checkbox-group>

                  <div class="switch-sec">
                    <p>7 Days</p>
                    <label class="switch">
                      <input
                        v-model="isMonthlyPlan"
                        @change="
                          premium_pricing_duration = isMonthlyPlan == true ? '30' : '7';
                          setPricing();
                        "
                        type="checkbox"
                      />
                      <span class="slider round"></span>
                    </label>
                    <p>30 Days</p>

                    <img
                      src="../../assets/images/Youtube Icon.png"
                      @click="
                        activeVideo = 'https://www.youtube.com/embed/umwESJwcelY?si=ciULvMUqNRtQK3T1';
                        videoDialog = true;
                      "
                      style="cursor: pointer; width: 25px; height: 25px; margin-top: 0; margin-left: 8px"
                      alt=""
                    />
                  </div>

                  <el-button class="subscribed-btn" v-if="Object.keys(getSubscribedPlanDetails).length && getSubscribedPlanDetails.plan == 'Premium'" style="width: 100%">Subscribed</el-button>
                  <el-button style="width: 100%" class="subscribed-btn" v-else @click="!userProfile ? goToLogin() : selectPlan('PREMIUM')">Start now</el-button>
                  <div class="list mobile-view-table">
                    <table style="width: 100%">
                      <tr>
                        <th style="text-align: left">Feature</th>
                        <th>Equity</th>
                        <th>Options</th>
                      </tr>
                      <tr v-for="(data, dataIndex) in selectedPricingData" :key="dataIndex">
                        <td style="text-align: left">
                          <div v-if="!data.isHeading && data.premium.equity != false">
                            <p>
                              {{ data.feature }}
                            </p>
                          </div>
                          <div v-else>
                            <div style="font-size: 16px; margin: 15px 0; font-weight: 700">
                              {{ data.feature }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div v-if="!data.isHeading && data.premium.equity != false">
                            <div class="status yellow" v-if="data.premium.equity.length">
                              <p>
                                {{ data.premium.equity }}
                              </p>
                            </div>
                            <div class="status yellow" v-if="data.premium.equity == true">
                              <i class="el-icon-success"></i>
                            </div>
                            <div v-else></div>
                          </div>
                          <div v-else></div>
                        </td>
                        <td>
                          <div v-if="!data.isHeading && data.premium.equity != false">
                            <div class="status yellow" v-if="data.premium.options.length">
                              <p>
                                {{ data.premium.options }}
                              </p>
                            </div>
                            <div class="status yellow" v-if="data.premium.options == true">
                              <i class="el-icon-success"></i>
                            </div>
                            <div v-else></div>
                          </div>
                          <div v-else></div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="table-main">
            <table>
              <tr>
                <th style="border-right: 1px solid #ddd; width: 33%" rowspan="2">
                  <div class="price-header text-left">Features</div>
                </th>
                <th style="width: 23%" colspan="2">
                  <div class="blue-color"></div>
                  <div class="price-header">
                    <div class="flex-space-between">
                      <div>Premium</div>
                      <div>
                        <div>
                          ₹ {{ premium_pricing_Cost }}
                          <span style="font-size: 9px">{{ isMonthlyPlan ? '/ 30 Days' : '/ 7 Days' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <td>
                  <div class="sub-price-header text-center">Equity</div>
                </td>
                <td>
                  <div class="sub-price-header text-center">Options</div>
                </td>
              </tr>

              <tr v-for="(data, data_index) in selectedPricingData" :key="data_index">
                <td class="feature">
                  <div class="flex-space-between">
                    <p v-if="!data.isHeading">
                      {{ data.feature }}
                    </p>
                    <p v-else style="font-size: 18px; font-weight: 700; margin: 10px 0">
                      {{ data.feature }}
                    </p>

                    <img
                      v-if="!data.isHeading && data.videoLink.length"
                      src="../../assets/images/Youtube Icon.png"
                      @click="
                        activeVideo = data.videoLink;
                        videoDialog = true;
                      "
                      style="cursor: pointer"
                      alt=""
                      width="20px"
                    />
                  </div>
                </td>

                <td>
                  <div v-if="!data.isHeading">
                    <div v-if="data.premium.equity.length">
                      <div class="status blue">
                        {{ data.premium.equity }}
                      </div>
                    </div>
                    <div v-if="data.premium.equity == true">
                      <div class="status blue">
                        <i class="el-icon-success"></i>
                      </div>
                    </div>
                    <div v-if="data.premium.equity == false">
                      <div class="status blue">
                        <i class="el-icon-error"></i>
                      </div>
                    </div>
                    <div v-else></div>
                  </div>
                  <div v-else></div>
                </td>
                <td>
                  <div v-if="!data.isHeading">
                    <div v-if="data.premium.options.length">
                      <div class="status blue">
                        {{ data.premium.options }}
                      </div>
                    </div>
                    <div v-if="data.premium.options == true">
                      <div class="status blue">
                        <i class="el-icon-success"></i>
                      </div>
                    </div>
                    <div v-if="data.premium.options == false">
                      <div class="status blue">
                        <i class="el-icon-error"></i>
                      </div>
                    </div>
                    <div v-else></div>
                  </div>
                  <div v-else></div>
                </td>
              </tr>
            </table>
          </div>
        </el-col>
      </el-row>
    </div>

    <div id="video-section">
      <el-dialog :visible.sync="videoDialog" :before-close="videoDialogClose" center>
        <div class="iframe-container">
          <iframe id="videoId" width="100%" height="600px" :src="activeVideo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </el-dialog>
    </div>

    <!-- confirm payment dialog -->
    <div class="payment-success-dialog">
      <div class="modal" v-if="is_confirm_plan_purchase_dialog_visible">
        <div class="modal-content" v-loading="is_purchase_plan_in_progress">
          <div class="dailog-bg">
            <span class="close" @click="handleClosePurchasePlanDialog()"><i class="el-icon-close"></i></span>
            <div class="plan-details-section top-margin-20">
              <el-row>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="first-col">
                  <div>
                    <span class="title">Selected Plan</span>
                  </div>

                  <div class="top-margin-10">
                    <div class="label-md-bold-black" style="font-size: 1.5rem; color: #fff; font-weight: bold">
                      {{ selected_plan.plan }}&nbsp;
                      <span v-if="selected_plan.plan == 'Premium'">
                        <img src="../../assets/images/plan2.png" style="width: 22px" />
                      </span>
                    </div>
                  </div>
                </el-col>

                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="second-col">
                  <div class="top-margin-10">
                    <div class="label-md-bold-black" style="font-size: 1.5rem; color: #fff">
                      ₹ {{ selected_plan.price }}

                      <span class="sub-title" v-if="selected_plan.plan == 'Lite'">/ Month</span>

                      <span class="sub-title" v-if="selected_plan.plan == 'Premium'">
                        /
                        {{ premium_pricing_duration == 30 ? 'Month' : premium_pricing_duration == 7 ? '7 Days' : premium_pricing_duration == 1 ? '24 Hrs' : '' }}
                      </span>
                    </div>

                    <small style="font-size: 0.7rem; color: #fff; font-weight: 500" v-if="selected_plan.plan != 'Lite'">(Incl of all service charges)</small>
                  </div>

                  <div class="sub-title top-margin-5 text-right">Plan period - {{ selected_plan.duration }} days</div>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="dialog-decp">
            <div class="flex" style="align-items: flex-start" v-if="selected_plan.plan != 'Publisher'">
              <el-checkbox class="right-margin-10" v-model="accept_stockants_agreement"></el-checkbox>
              <div>
                <span class="label-md-bold-black" style="font-size: 0.8rem">I have read</span>

                <u class="primary-theme-color cursor-pointer font-weight-600 font-08rem" @click="downloadSubscriptionAgreement()">StockAnts Subscription Agreement</u>
              </div>
            </div>

            <!-- if selected plan is lite plan then confirm button enabled -->
            <!-- if selected plan is premium or pro then to enable confirm payment button need to check agreement-->
            <div class="btn-section text-center top-margin-25">
              <el-button class="dwnld-btn" @click="confirmPayment()" :disabled="selected_plan.plan == 'Lite' ? false : !accept_stockants_agreement && (selected_plan.plan == 'Premium' || selected_plan.plan == 'Pro') ? true : false">Confirm</el-button>

              <el-button
                class="cancel-btn"
                @click="
                  removeQueryParam();
                  is_confirm_plan_purchase_dialog_visible = false;
                "
              >
                Cancel
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- unsubscribe plan notification dialog -->
    <el-dialog class="unsubscribe-plan-notification-dialog" :visible.sync="unsubscribe_plan_notiifcation_dialog" :before-close="handleUnsubscribePlanNoticiationDialogClose">
      <div style="word-break: break-word">
        <div class="text-center" style="font-size: 17px; color: #000; font-weight: 600">
          You are already subscribed to StockAnts
          {{ getSubscribedPlanDetails ? getSubscribedPlanDetails.plan : '' }}
          plan
        </div>
        <div class="label-md-bold-black text-center top-margin-5" style="font-size: 17px; color: #000; font-weight: 600">Please unsubscribe that first</div>
        <span slot="footer" class="dialog-footer flex-center top-margin-25">
          <div class="font-09rem">
            Click
            <u
              class="primary-theme-color cursor-pointer"
              @click="
                $router.push({ path: '/my-account' });
                unsubscribe_plan_notiifcation_dialog = false;
              "
            >
              here
            </u>
            to check Subscribed Plan details
          </div>
        </span>
      </div>
    </el-dialog>

    <!-- update profile details dialog -->
    <el-dialog class="unsubscribe-plan-notification-dialog" :visible.sync="update_profile_details_notiifcation_dialog" :before-close="handleProfileDetailsNoticiationDialogClose" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <div style="word-break: break-word">
        <div class="text-center" style="font-size: 17px; color: #000; font-weight: 600">Mobile No. verification is pending.</div>
        <div class="label-md-bold-black text-center top-margin-5" style="font-size: 17px; color: #000; font-weight: 600">Please verify.</div>
        <span slot="footer" class="dialog-footer flex-center top-margin-25">
          <div class="font-09rem">
            Click
            <u
              class="primary-theme-color cursor-pointer"
              @click="
                update_profile_details_notiifcation_dialog = false;
                $router.push({ path: '/profile-update' });
              "
            >
              here
            </u>
            to verify
          </div>
        </span>
      </div>
    </el-dialog>

    <div v-if="userProfile != null">
      <ProcessKycComponent :planDetails="planSubscriptionStatusDetails"></ProcessKycComponent>
    </div>
  </div>
</template>

<script>
import RetailFooter from '@/components/RetailSideCompo/RetailFooter.vue';
import Retailnavbar from '@/components/RetailSideCompo/RetailNavbar.vue';
import { serverAddr, serverHostName } from '../../networkConfig';
import { filterCallBack } from '../../mixins/filter';
import { screenSize } from '../../mixins/ScreenSize.js';
import PlainSideBar from '@/components/PlainSideBar.vue';
import MobileNav from '@/components/MobileNav.vue';
import CripNotice from 'crip-vue-notice';
import NoDataFound from '@/components/NoDataFound.vue';
import { EventBus } from '../../eventBus';
import moment from 'moment';
import { credentials, cashfreeCredentials } from '../../mixins/Credentials.js';
import { updateProfileNetworkCallBack } from '../../mixins/UpdateProfile.NetworkCallBack';
import cashfreePromise from '../../mixins/cashfreeInit.js';
import ProcessKycComponent from '@/components/NewKycFlow.vue';

export default {
  name: 'RetailPricingComponent',
  mixins: [filterCallBack, screenSize, credentials, updateProfileNetworkCallBack],
  components: {
    PlainSideBar,
    MobileNav,
    NoDataFound,
    RetailFooter,
    Retailnavbar,
    ProcessKycComponent,
  },
  data() {
    return {
      activePlanType: 'Premium',
      planSubscriptionStatusDetails: null,
      isMonthlyPlan: false,
      is_mobile_verification_loading: false,
      centerDialogVisible: false,
      videoDialog: false,
      activeVideo: '',
      userType: '',
      role: '',
      otp: '',
      showExpertData: false,
      mobile_number: '',
      email: '',
      validate_email_id: false,
      acceptTerms: false,
      // userProfile: null,
      nav_title: 'Pricing Plans',
      selectedMarketOption: ['Equity', 'Options'],
      is_subscribed_plan_details_loading: false,
      is_confirm_plan_purchase_dialog_visible: false,
      is_purchase_plan_in_progress: false,
      unsubscribe_plan_notiifcation_dialog: false,
      update_profile_details_notiifcation_dialog: false,
      order_id: '',
      subscription_id: '',
      transaction_id: '',
      transaction_token: '',
      selected_plan: {
        plan: '',
        price: '',
        duration: '',
        trial_period: '',
      },
      accept_stockants_agreement: false,
      checksum: '',
      credentials: credentials,
      serverHostName: serverHostName,
      role: '',

      marketExpertUsersPricing: [
        {
          feature: 'Full Access to Expert View',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },

        {
          feature: 'Access to StockAnts Performers',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: 'NA',
          },
          videoLink: 'https://www.youtube-nocookie.com/embed/zVvlqljk72g',
        },
        {
          feature: 'Access to Trade section',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Full Access to Markets',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Full access to Expert’s performance overview',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: 'NA',
          },
          videoLink: '',
        },
        {
          feature: 'Full Access to filter stack',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Access to Market Sentiment',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Access to Antestimate',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: 'NA',
          },
          videoLink: '',
        },
        {
          feature: 'Unrestricted Access to entire platform',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Publish unlimited opinions',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: 'https://www.youtube-nocookie.com/embed/GxIshG2eNXQ',
        },
        {
          feature: 'Share access of your portfolio to your clients',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: false,
            options: false,
          },
          videoLink: '',
        },
      ],

      retailUsersPricing: [
        {
          feature: 'Track',
          isHeading: true,
        },
        {
          feature: 'Bundle of SEBI RA & RIA',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Daily 15+ Strategies',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Access to Equity and Options ready strategies',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Price estimates tracking of experts advise',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Trust',
          isHeading: true,
        },
        {
          feature: 'Experts’ Performance Overview',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: 'NA',
          },
          videoLink: '',
        },
        {
          feature: 'Trading cost Estimator',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Market Sentiment',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: 'NA',
          },
          videoLink: '',
        },
        {
          feature: 'Screeners',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: 'NA',
          },
          videoLink: '',
        },
        {
          feature: 'Trade',
          isHeading: true,
        },
        {
          feature: 'Post trade support of watchlist & notification',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Access your trade book on StockAnts',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
        {
          feature: 'Get full trade support of Bracket order And Limit order',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        },
      ],
      selectedPricingData: [],
      currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
      websiteUserType: {},
      currentEnvironment: {},
      gatewayMode: '',
      session_id: null,
      internalTeamMailList: ['joshiakshay7191office@gmail.com', 'chiragp0310@gmail.com', 'krishaa0801@gmail.com', 'joshiakshay719@gmail.com', 'fegde.mayur@gmail.com', 'snehalvpatil25@gmail.com', 'sumittarkas0001@gmail.com', 'bid.pallavi@gmail.com', 'pallavi.bid@stockants.com', 'bhushanm705811@gmail.com', 'admin@stockants.com', 'sumittarkas001@gmail.com', 'satavchetan08@gmail.com', 'amanm3047@gmail.com'],
      plansDetails: null,
      chatPackages: [
        { label: '1 Chat', price: 299, duration: 15, chatCount: 1 },
        { label: '3 Chats', price: 335, duration: 30, chatCount: 3 },
        { label: '5 Chats', price: 350, duration: 45, chatCount: 5 },
      ],
      selectedPackage: '1 Chat',
      selectedChatPackage: {
        label: '1 Chat',
        price: 299,
        duration: 15,
        chatCount: 1,
      },
      activeCollapse: ['1'],
      premium_pricing_duration: 7,
      premium_pricing_Cost: null,
    };
  },
  watch: {
    getPlanSubscriptionStatus(newValue, oldValue) {
      this.planSubscriptionStatusDetails = newValue.message;

      if (this.planSubscriptionStatusDetails && this.planSubscriptionStatusDetails.extra_info.transaction_status == 'SUCCESS') {
        if (this.planSubscriptionStatusDetails.data.plan == 'Publisher') {
          localStorage.setItem('publisher_plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
        } else {
          localStorage.setItem('plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
        }
        this.$store.commit('commitKycDialog', true);
      }
    },
  },

  mounted() {
    if (this.premium_pricing_duration == 30) {
      this.premium_pricing_Cost = credentials.PREMIUM_COST_THIRTY_DAYS;
    } else {
      this.premium_pricing_Cost = credentials.PREMIUM_COST_SEVEN_DAYS;
    }

    if (this.$route.query.method == 'subscribe_publisher') {
      this.selected_plan = {
        plan: 'Publisher',
        price: '999',
        duration: '30',
        trial_period: '',
      };

      this.subscribePlanPublisher();
    }
    // select user type for navigation access
    if (localStorage.getItem('websiteUserType')) {
      this.websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));
    }

    // get currentEnvironment details
    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
    }

    if (localStorage.getItem('premiumPlanSubscriptionDialogVisible') && (!Object.keys(this.getSubscribedPlanDetails).length || this.getSubscribedPlanDetails.plan !== 'Premium')) {
      this.selectPlan('PREMIUM');
    }

    this.selectedPricingData = this.showExpertData ? this.marketExpertUsersPricing : this.retailUsersPricing;

    if (this.websiteUserType.userSubType == 'brokerWithPlans') {
      // remove specific plan option for paytm money index 1
      this.selectedPricingData.splice(1, 1);
    }
    if (localStorage.getItem('profile')) {
      var role = JSON.parse(localStorage.getItem('profile'));
      this.userType = role.profession;
      if (!Object.keys(this.getSubscribedPlanDetails).length || !Object.keys(this.getChatPlanDetails).length) {
        this.getPlanDetails();
      }
    }

    this.addPlansForBroker();
  },

  created() {
    this.addConditionalFeature();
  },

  methods: {
    removeQueryParam() {
      // Access the current query parameters
      let queryParams = { ...this.$route.query };

      // Remove a specific query parameter (e.g., 'example')
      delete queryParams.method;

      // Update the URL without the query parameter
      this.$router.push({ query: queryParams });
    },

    subscribePlanPublisher() {
      this.removeQueryParam();
      this.is_confirm_plan_purchase_dialog_visible = true; //display confirm payment dialog
    },
    addPlansForBroker() {
      if (this.userType == 'Financial Advisor' || this.userType == 'Non Financial Advisor' || this.userType == 'Market Expert' || this.userType == 'Broker' || this.userType == 'ADVISOR' || this.userType == 'Analyst' || this.userType == 'BROKER') {
        this.showExpertData = true;
        this.selectedPricingData = this.showExpertData ? this.marketExpertUsersPricing : this.retailUsersPricing;
      }
    },
    goToLogin() {
      if (this.currentUrl.includes('paytmmoney.stockants.com')) {
        this.getRedirectURLForBroker();
      } else {
        this.$router.push('/login');
      }
    },
    getRedirectURLForBroker() {
      serverAddr
        .get(`auth/v1/level_one_auth_for_broker?broker_id=10`)
        .then((response) => {
          if (response.data.status) {
            window.location.href = response.data.data.redirect_url;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setPricing() {
      if (this.isMonthlyPlan) {
        this.premium_pricing_Cost = credentials.PREMIUM_COST_THIRTY_DAYS;
      } else {
        this.premium_pricing_Cost = credentials.PREMIUM_COST_SEVEN_DAYS;
      }
    },
    videoDialogClose() {
      this.videoDialog = false;
      let video = document.getElementById('videoId');
      let url = video.getAttribute('src');
      video.setAttribute('src', '');
      video.setAttribute('src', url);
    },
    changeValidity() {
      if (this.isMonthlyPlan) {
        this.packValue = '';
      }
    },

    // api to get profile data e.g. name, email
    getUserProfile() {
      serverAddr
        .get('/auth/v1/profile')
        .then(this.getProfileCallBack)
        .catch(function (error) {
          console.log(error);
        });
    },

    selectPlan(plan) {
      this.centerDialogVisible = false;
      // else if selected plan is premium plan and user has already subscribed to pro plan then displayed unsubscribe plan first dialog (warning dialog)
      if (!this.userProfile.mobile_verified) {
        this.update_profile_details_notiifcation_dialog = true;
      } else {
        if (Object.keys(this.getSubscribedPlanDetails).length) {
          //if object has  length
          if (plan == 'LITE' && (this.getSubscribedPlanDetails.plan == 'Premium' || this.getSubscribedPlanDetails.plan == 'Pro')) {
            this.unsubscribe_plan_notiifcation_dialog = true; //display already subscribed plan warning dialog
          } else if (plan == 'PREMIUM' && this.getSubscribedPlanDetails.plan == 'Pro') {
            this.unsubscribe_plan_notiifcation_dialog = true; //display already subscribed plan warning dialog
          } else {
            this.is_confirm_plan_purchase_dialog_visible = true; //display confirm payment dialog
          }
        } else {
          this.is_confirm_plan_purchase_dialog_visible = true; //display confirm payment dialog
        }

        localStorage.removeItem('premiumPlanSubscriptionDialogVisible');

        this.selected_plan = {
          plan: '',
          price: '',
          duration: '',
          trial_period: '',
        };

        this.accept_stockants_agreement = false; //reset on dialog open

        if (plan == 'LITE') {
          this.selected_plan.plan = 'Lite';
          this.selected_plan.price = 0;
          this.selected_plan.duration = 'Lifetime';
        } else if (plan == 'PREMIUM') {
          this.selected_plan.plan = 'Premium';
          this.selected_plan.price = this.premium_pricing_Cost; //premium pricing for 24 hrs will be 60rs and 350rs for 30 days
          this.selected_plan.duration = this.premium_pricing_duration;
        }
      }
    },

    // close unsubscribe plan notification dialog
    handleUnsubscribePlanNoticiationDialogClose() {
      this.unsubscribe_plan_notiifcation_dialog = false;
    },

    // close unsubscribe plan notification dialog
    handleProfileDetailsNoticiationDialogClose() {
      this.update_profile_details_notiifcation_dialog = false;
    },

    // close purchase plan dialog
    handleClosePurchasePlanDialog() {
      this.is_confirm_plan_purchase_dialog_visible = false;
    },

    // function returns 30 days from current date
    getPlanTimePeriod(plan, duration) {
      // if plan is premium then 7 days will be free trial days and after 7th days actual subscription will start

      let time_period = '';

      if (plan == 'PREMIUM') {
        var currentDate = moment().add(0, 'days');
      } else if (plan == 'PRO') {
        // if plan is pro then 15 days will be free trial days and after 15th days actual subscription will start
        var currentDate = moment().add(0, 'days');
      }

      if (duration == 1) {
        time_period = `${moment().format('DD MMM YYYY')} to ${moment().add(1, 'days').format('DD MMM YYYY')}`;
      } else {
        var futureMonth = moment(currentDate).add(1, 'M');
        var futureMonthEnd = moment(futureMonth).endOf('month');

        if (currentDate.date() != futureMonth.date() && futureMonth.isSame(futureMonthEnd.format('YYYY-MM-DD'))) {
          futureMonth = futureMonth.add(1, 'd');
        }

        time_period = `${moment(currentDate).format('DD MMM YYYY')} to ${moment(futureMonth).format('DD MMM YYYY')}`;
      }

      return time_period;
    },

    // function to confirm payment and call api accordingly
    confirmPayment() {
      if (this.selected_plan.plan == 'Premium' || this.selected_plan.plan == 'Publisher') {
        // api to get order id
        this.getOrderId('Premium');
      }
    },

    getOrderId(planType) {
      this.is_purchase_plan_in_progress = true; // enable loader

      // Determine the plan details based on planType
      let planName, planDays, currentPrice, orderCategoryId, description;

      if (planType === 'Premium') {
        // If plan is premium, calculate days and price
        if (this.premium_pricing_duration == 0) {
          this.premium_pricing_duration = this.isMonthlyPlan ? 30 : 7;
        }
        planDays = this.selected_plan.plan === 'Premium' ? Number(this.premium_pricing_duration) : 30;
        currentPrice = Number(this.selected_plan.price);

        if (this.internalTeamMailList.includes(this.userProfile.email)) {
          currentPrice = 1;
        }

        planName = this.selected_plan.plan;
        orderCategoryId = 3;
        description = 'Plan Subscription';
      } else if (planType === 'Chat') {
        // For chat plan
        this.chatPlanDetailsPopup = false;

        // let selectedChatPlan = this.chatPackages.find((plan) => plan.label === this.selectedPackage);

        // planName = 'StockAnts Chat';
        // planDays = selectedChatPlan.duration;
        // currentPrice = selectedChatPlan.price * selectedChatPlan.chatCount;
        // orderCategoryId = 4;
        // description = 'Plan Subscription';

        planName = 'StockAnts Chat';
        planDays = this.selectedChatPackage.duration;
        currentPrice = this.selectedChatPackage.price * this.selectedChatPackage.chatCount;
        orderCategoryId = 4;
        description = 'Plan Subscription';
      }

      if (planDays >= 7) {
        serverAddr
          .post('/payment/v3/generate_order_id/', {
            plan_name: planName,
            days: planDays,
            amount: currentPrice,
            order_category_id: orderCategoryId,
            description: description,
            pg: 'CASHFREE',
          })
          .then((response) => {
            if (response.data.status) {
              this.order_id = response.data.data.order_id; // get order id
              this.session_id = response.data.data.session_id;

              this.initCashfree();
            } else {
              this.showErrorMessage();
            }

            this.is_purchase_plan_in_progress = false; // disable loader
          })
          .catch((error) => {
            console.log(error);
            this.order_id = '';
            this.is_purchase_plan_in_progress = false; // disable loader
            this.showErrorMessage();
          });
      } else {
        this.showErrorMessage();
      }
    },

    showErrorMessage() {
      new CripNotice({
        title: 'Oops! Something went wrong!',
        description: 'Please try again',
        type: 'error',
        duration: 3,
      });
    },

    async initCashfree() {
      try {
        // Wait for the cashfreePromise to resolve, which contains the initialized Cashfree SDK
        const cashfree = await cashfreePromise;

        // Check if this.session_id is defined and not empty
        if (!this.session_id) {
          console.error('Error: paymentSessionId is missing or undefined');
          return; // Exit the function if session_id is missing or undefined
        }

        var currentPrice = this.isMonthlyPlan ? credentials.PREMIUM_COST_THIRTY_DAYS : credentials.PREMIUM_COST_SEVEN_DAYS;

        if (this.internalTeamMailList.includes(this.userProfile.email)) {
          currentPrice = 1;
        }

        // Construct options for checkout
        const checkoutOptions = {
          paymentSessionId: this.session_id,
          appId: cashfreeCredentials.appId,
          orderId: this.order_id,
          orderAmount: currentPrice,
          orderCurrency: 'INR',
          customerName: credentials.NAME,
          redirectTarget: '_modal',
        };

        // Initiate payment using checkout
        cashfree.checkout(checkoutOptions).then((result) => {
          if (result.error) {
            // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
            console.log('User has closed the popup, Check for Payment Status');
            console.log(result.error);
          }
          if (result.redirect) {
            // This will be true when the payment redirection page couldnt be opened in the same window
            // This is an exceptional case only when the page is opened inside an inAppBrowser
            // In this case the customer will be redirected to return url once payment is completed
            console.log('Payment will be redirected');
          }
          if (result.paymentDetails) {
            // This will be called whenever the payment is completed irrespective of transaction status
            console.log('Payment has been completed, Check for Payment Status');

            this.is_confirm_plan_purchase_dialog_visible = false;
            // this.getTransactionDetailsFromCashFree();
            console.log(result.paymentDetails.paymentMessage);
            this.getCashfreeTransactionDetails();
          }
        });
      } catch (error) {
        console.error('Error initializing Cashfree SDK:', error);
      }
    },

    getCashfreeTransactionDetails() {
      if (this.order_id) {
        setTimeout(() => {
          serverAddr
            .get(`payment/v3/plan_details_from_order_id/${this.order_id}`)
            .then((response) => {
              // this.is_confirm_plan_purchase_dialog_visible = false;
              var plan_data = response.data.response;

              if (plan_data.extra_info.module == 'PLAN_PURCHASED' && (plan_data.data.plan == 'Premium' || plan_data.data.plan == 'Publisher' || plan_data.data.plan == 'StockAnts Chat')) {
                this.$store.commit('storePlanStatus', plan_data);
                this.$store.commit('commitQRCodePopup', false);
                if (plan_data.data.plan.length) {
                  this.$store.commit('storePaymentStatus', true);
                }
              }

              if (plan_data && plan_data.extra_info.transaction_status == 'SUCCESS') {
                // this.storePlansData(plan_data.data);
                if (plan_data.data.plan == 'Publisher') {
                  this.$store.commit('commitPublisherPlanDetails', plan_data.data);
                  this.saveSubscribedPublisherPlanDetails(plan_data.data);
                } else if (plan_data.data.plan == 'StockAnts Chat') {
                  this.$store.commit('commitChatPlanDetails', plan_data.data);
                  this.saveSubscribedChatPlanDetails(plan_data.data);
                } else {
                  this.$store.commit('commitSubscribedPlanDetails', plan_data.data);
                  this.saveSubscribedPlanDetailsToLocalStorage(plan_data.data);
                }

                this.$store.commit('commitKycDialog', true);
              }
            })
            .catch(
              function (error) {
                console.log(error);
              }.bind(this)
            );
        }, 2000);
      }
    },

    getPlanDetails() {
      this.is_subscribed_plan_details_loading = true; //enabled loader
      serverAddr
        .post('/stockants_pro/get-user-subscription/', {})
        .then((response) => {
          if (response.data.status && response.data.data.length) {
            var activePremiumPlan = response.data.data.find((plan) => plan.plan === 'Premium' || plan.plan === 'Lite');
            activePremiumPlan = activePremiumPlan ? activePremiumPlan : {};

            var publisherPlans = response.data.data.find((plan) => plan.plan === 'Publisher');
            publisherPlans = publisherPlans ? publisherPlans : {};

            var stockAntsChatPlan = response.data.data.find((plan) => plan.plan === 'StockAnts Chat');
            stockAntsChatPlan = stockAntsChatPlan ? stockAntsChatPlan : {};

            // Save Premium plan details
            this.$store.commit('commitSubscribedPlanDetails', activePremiumPlan);
            this.saveSubscribedPlanDetailsToLocalStorage(activePremiumPlan);

            // Save Publisher plan details
            this.$store.commit('commitPublisherPlanDetails', publisherPlans);
            this.saveSubscribedPublisherPlanDetails(publisherPlans);

            // Save Publisher plan details
            this.$store.commit('commitChatPlanDetails', stockAntsChatPlan);
            this.saveSubscribedChatPlanDetails(stockAntsChatPlan);
          }
          this.is_subscribed_plan_details_loading = false; //disabled loader
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_subscribed_plan_details_loading = false; //disabled loader
          }.bind(this)
        );
    },

    getActivePlan(subscriptionData) {
      const planTypes = ['Premium', 'Pro'];
      let activePlan = {};

      for (const planType of planTypes) {
        const filteredPlans = subscriptionData.filter((item) => item.plan === planType);
        if (filteredPlans.length) {
          const isActive = this.checkActivePlanStatus(filteredPlans[0]);
          if (isActive) {
            activePlan = filteredPlans[0];
            break;
          }
        }
      }

      return activePlan;
    },

    checkActivePlanStatus(plan) {
      const today = new Date();

      // Define the start and end dates
      const startDate = new Date(plan.purchase_date);
      const endDate = new Date(plan.expire_date);

      // Check if today's date is between the start and end dates
      if (today >= startDate && today <= endDate) {
        return true;
      } else {
        return false;
      }
    },

    downloadSubscriptionAgreement() {
      window.open(`${this.serverHostName}/Media/important_doc/StockAntsSubscriptionAgreement.pdf`, '_blank');
    },

    addConditionalFeature() {
      if (this.websiteUserType.userType !== 'broker') {
        this.marketExpertUsersPricing.push({
          feature: 'Access to multiple Brokers using Access Code',
          pro: {
            equity: true,
            options: true,
          },
          premium: {
            equity: true,
            options: true,
          },
          videoLink: '',
        });
      }
    },
  },

  computed: {
    getPlanSubscriptionStatus() {
      return this.$store.state.planStatus;
    },

    getSubscribedPlanDetails() {
      return this.$store.state.subscribed_plan_details;
    },

    getPublisherPlanDetails() {
      return this.$store.state.publisher_plan_details;
    },

    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    planDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },

    getChatPlanDetails() {
      return this.$store.state.chat_plan_details;
    },

    // isPremiumPlanDialogStatus() {
    //     return this.$store.state.is_subscribe_premium_plan_dialog_visible;
    // }
  },
  beforeDestroy() {
    EventBus.$off();

    if (localStorage.getItem('premiumPlanSubscriptionDialogVisible')) {
      localStorage.removeItem('premiumPlanSubscriptionDialogVisible');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../css/variable.scss';
@import '../../css/common.scss';

// #813fc5
.retail-side-pricing {
  .faq-section {
    .faq-title {
      font-weight: 600;
      font-size: 20px;
      margin: 30px 0 20px;
    }

    .card-container {
      margin-top: 30px;

      .question {
        font-size: 14px;
        font-weight: 600;
      }

      .answer {
        font-size: 12px;
        font-weight: 500;
        color: #939393 !important;
        margin-top: 10px;
        line-height: 1 !important;
      }
    }
  }

  .chat-pricing-card {
    .chat-note {
      font-size: 12px;
      font-weight: 500;
      text-align: left;
      margin: 10px 0 0;
    }
  }

  .chat-details-card {
    .partition-line {
      width: 30%; // Set the width of the partition line to 20%
      height: 1px; // Adjust the height of the line
      background-color: #9d9d9d; // Set the color of the line
      margin: 20px auto; // Center the line horizontally
    }

    .chat-details-card-inner {
      .drawer-content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-around;

        .inner-content {
          margin: 0 auto;
          text-align: center;
          margin-top: 10px;
        }

        .drawer-heading {
          font-size: 23px;
          font-weight: bold;
          color: #2488ff;
          margin: 0;
        }

        .drawer-subtext {
          font-size: 14px;
          color: #868686;
          margin: 0;
          font-style: italic;
          font-weight: 500;
        }

        .details-list {
          padding: 0;
          margin: 20px auto;
          width: 280px;

          .points {
            display: flex;
            font-size: 14px;
            margin: 15px 0;
            font-weight: 500;

            i {
              font-size: 20px;
              position: relative;
              bottom: 1px;
              right: 7px;
              color: #2488ff;
            }
          }
        }
      }
    }
  }

  .toggle-button {
    display: flex;
    border-radius: 10px;
    overflow: hidden;
    width: 250px;
    margin: auto;
    background-color: #e4e4e4;
    margin-top: 35px;

    .toggle-option {
      flex: 1;
      padding: 10px 10px 12px;
      text-align: center;
      cursor: pointer;
      border: none;
      transition: background-color 0.3s ease;
      font-size: 15px;
      background-color: #e4e4e4;
      color: #a0a0a0;
      font-weight: 600;

      &:first-child {
        border-radius: 10px;
      }

      &:last-child {
        border-radius: 10px;
      }
    }

    .active-premium {
      background-color: #2e318d; // Yellow for Premium
      color: white;
    }

    // Active Chat Button
    .active-chat {
      background-color: #2488ff; // Green for Chat
      color: white;
    }

    .chat {
      img {
        position: relative;
        top: 4px;
        left: 1px;
      }
    }
  }

  .cancel-btn:hover {
    background-color: #2d2e8d;
    color: #ffff !important;
  }

  .premium_plan_message {
    margin: 0 0 20px;
    background-color: #2d2e8d;
    padding: 15px 40px 10px;

    .inner {
      .offer-icon {
        width: 105px;
        margin-right: 15px;
      }

      .first-head {
        font-size: 1rem; // color: #f23232;
        color: #ffff;
        font-weight: 600;
      }
    }
  }

  .main-head {
    color: #565555;
    margin-top: 30px;
    font-size: 2.2rem;
  }

  p {
    word-break: normal !important;
  }

  .details-card {
    margin: 20px 0;

    .stockants-card {
      height: 400px !important;
      margin: 40px 20px;
      padding: 0 20px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .stockants-title {
        font-size: 2.2rem;
        font-weight: 700;
      }

      .try-sentence {
        font-size: 0.9rem;
        margin: 10px 0;
        font-weight: 500;
        color: gray;
      }
    }

    .special-card {
      height: 370px;
      margin: 40px 20px;
      border: 1px solid #b8b8b87a;
      width: 350px;
      border-radius: 10px;
      box-shadow: 0px 0px 9px 4px #33333326;
      background-color: #ffff;

      .top-line {
        border-radius: 10px 10px 0 0;
        height: 12px;
        margin-top: -3px;
      }

      .inner-card {
        padding: 0 20px 20px;

        .list {
          display: none;
          text-align: left;

          p {
            // font-size: 0.9rem;
            font-size: 0.85rem;
            color: #5c5c5c; // font-weight: 600;

            span {
              position: relative;
              top: 4px;
            }
          }
        }

        .plan-title {
          font-size: 18px;
          font-weight: 600;
        }

        .cost {
          font-size: 2.3rem;
          font-weight: 600;
          margin: 10px 0 0;
        }

        .chat-duration {
          font-size: 15px;
          font-weight: 600;
        }

        img {
          width: 70px;
          height: 70px;
        }

        .switch-sec {
          display: flex;
          justify-content: center;
          align-items: center;

          p {
            font-size: 0.85rem;
            color: gray;
            font-weight: 700;
          }
        }

        .switch {
          position: relative;
          display: inline-block;
          width: 50px;
          height: 25px;
          margin: 20px 10px;
        }

        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #2d2e8d;
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }

        .slider:before {
          position: absolute;
          content: '';
          height: 21px;
          width: 21px;
          left: 1px;
          bottom: 2px;
          background-color: white;
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }

        input:checked + .slider {
          background: #2d2e8d;
        }

        input:focus + .slider {
          box-shadow: 0 0 1px #2196f3;
        }

        input:checked + .slider:before {
          -webkit-transform: translateX(26px);
          -ms-transform: translateX(26px);
          transform: translateX(26px);
        }

        /* Rounded sliders */
        .slider.round {
          border-radius: 34px;
        }

        .slider.round:before {
          border-radius: 50%;
        }
      }
    }

    .yellow {
      .top-line {
        background: #fdda0d;
      }
    }

    .blue {
      .top-line {
        background: #2e318d;
      }
    }

    .chat {
      .top-line {
        background: #2488ff;
      }
    }
  }

  .table-main {
    margin: 50px 0;

    .yellow-color {
      height: 7px;
      background: #fdda0d;
      position: relative;
      top: -6px;
    }

    .blue-color {
      height: 7px;
      background: #2e318d;
      position: relative;
      top: -6px;
    }

    .price-header {
      // margin: 20px;
      color: #565555;
      font-size: 16px;
      font-weight: 700;
      padding: 35px 20px;
    }

    .sub-price-header {
      // margin: 20px;
      color: #565555;
      font-size: 16px;
      font-weight: 700;
    }

    table,
    td,
    th {
      border-bottom: 1px solid #ddd; // text-align: left;
    }

    table {
      border-collapse: collapse;
      width: 100%;
      box-shadow: 0px 0px 9px 4px #2525252e;
      border-radius: 8px;
    }

    td {
      border-right: 1px solid #ddd;
      padding: 15px 30px;
      font-weight: 500;
    }

    th {
      border-right: 1px solid #ddd;
    }

    .status {
      text-align: center;
      font-size: 0.9rem;
    }

    .feature {
      text-align: left;
      font-size: 14px;
      font-weight: 500;
      border-right: 1px solid #ddd;
    }
  }

  @media screen and (max-width: 1283px) {
    padding: 50px 0 70px 0;
  }

  @media screen and (max-width: 991px) {
    .table-main {
      display: none;
    }

    .details-card {
      .pricing-main-cards {
        flex-direction: column;
      }

      .special-card {
        height: auto;
        width: 500px;
        margin: 20px auto;

        .inner-card {
          .list {
            display: block;
          }

          .mobile-view-table {
            margin-bottom: 20px;

            table,
            th {
              border: 1px solid #a19b9b;
              padding: 10px;
              font-size: 0.9rem;
              color: #3f3e3e;
              font-weight: 600;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              border-radius: 10px;
              border-style: hidden;
              /* hide standard table (collapsed) border */
              box-shadow: 0px 0px 3px 1px #717171;
              text-align: center;
            }

            td {
              padding: 0px 10px;
              border-right: 1px solid #a19b9b;
              font-weight: 500 !important;
            }
          }

          .subscribed-btn {
            margin-top: 0 !important;
            margin-bottom: 20px;
          }
        }
      }

      .stockants-card {
        height: 370px;
        width: 360px;
        margin: 20px auto;

        .stockants-title {
          i {
            display: none;
          }
        }
      }
    }
  }

  @media screen and (max-width: 770px) {
    .paytmMoney-section .premium_plan_message .inner .offer-icon {
      width: 75px;
    }
  }

  @media screen and (max-width: 620px) {
    .premium_plan_message {
      padding: 15px 10px 15px;
      margin: 0;

      .inner .first-head {
        font-size: 0.65rem;
        margin: 20px 0px;
      }
    }
  }

  @media screen and (max-width: 520px) {
    padding: 20px 0 0 0;

    .main-head {
      font-size: 1.5rem;
      margin-top: 10px;
    }

    .details-card {
      .special-card {
        width: 100% !important;
      }

      .stockants-card {
        width: 87%;
      }
    }

    .chat-pricing-card .special-card {
      width: 95% !important;
    }
  }

  @media screen and (max-width: 380px) {
    .details-card .special-card .inner-card {
      padding: 0px 10px 20px;

      .el-button {
        // width: 92% !important;
      }
    }

    .chat-pricing-card .chat-card-section .inner-content {
      // width: 270px;
      // width: 90%;
      margin: 0 auto;
    }

    .chat-pricing-card .chat-card-section .agreement-checkbox {
      p {
        font-size: 9px;
      }
    }
  }
}

.Pricing .btn-position {
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  text-align: center;

  .select-plan {
    background-color: transparent;
    border-color: $primary-theme-color;
    color: $primary-theme-color;
    font-size: 13px;
    height: 30px;
    line-height: 0.8;
    width: 250px;
  }

  .background-transparent {
    background-color: transparent;
  }

  .background-gradient {
    background-image: -webkit-gradient(linear, right top, left top, from(#dc6250), to(#eb5151));
    background-image: linear-gradient(to left, #dc6250, #eb5151);
    color: #fff;
    border: none;
  }
}

.retail-side-pricing .payment-success-dialog {
  .modal-content {
    .dailog-bg {
      background: $secondary-theme-color; // background: url('../assets/images/dashboard/dialog-background.png');
      background-repeat: no-repeat;
      background-position: center center;
      height: 120px;
      padding: 20px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }

    .dialog-decp {
      display: block !important;
    }

    .plan-details-section {
      .title {
        font-size: 0.9rem;
        color: #fff;
        font-weight: 600;
      }

      .sub-title {
        font-weight: 600;
        font-size: 0.7rem;
        color: #fff;
      }

      .first-col {
        text-align: left;
      }

      .second-col {
        text-align: right;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .modal-content .dailog-bg {
      height: 165px !important;
    }
  }
}

.retail-side-pricing {
  @media screen and (max-width: 620px) {
    .chat-details-card {
      .chat-details-card-inner {
        .drawer-content {
          .drawer-heading {
            font-size: 18px;
          }

          .drawer-subtext {
            font-size: 11px;
          }

          .details-list {
            width: 90%;
            text-align: left;

            .points {
              font-size: 12px;
            }
          }
        }
      }
    }

    .faq-section {
      .card-container {
        .question {
          font-size: 12px;
        }

        .answer {
          font-size: 10px;
        }
      }
    }
  }

  @media screen and (max-width: 400px) {
    .retail-side-pricing .chat-pricing-card .special-card {
      width: 95%;
      margin: 40px auto;
    }
  }
}
</style>

<style lang="scss">
@import '../../css/variable.scss';
@import '../../css/common.scss';

.retail-side-pricing {
  .faq-section {
    .card-container {
      .el-collapse-item__content {
        line-height: 1.3 !important;
      }

      .el-collapse-item__wrap,
      .el-collapse-item,
      .el-collapse-item__header {
        padding: 4px 0px;
      }
    }
  }

  .chat-details-card {
    .el-card {
      width: 620px;
      margin: 0 auto;
      border-radius: 20px;
    }

    .el-card__body {
      padding: 20px 55px 40px;
    }
  }

  .chat-pricing-card {
    .special-card {
      height: 380px;
      width: 350px !important;
    }

    .chat-card-section {
      flex: 1;
      // width: 350px;

      .inner-content {
        width: 290px;
        margin: 0 auto;
      }

      .pricing-table {
        margin: 0 auto;

        .table-titles {
          font-size: 0.7rem;
          font-weight: 500;
          margin: 12px 0;
        }

        .pricing-row {
          display: flex;
          justify-content: space-between;
          padding: 15px 10px;
          margin-bottom: 15px;
          // border: 1px solid #ddd;
          border-radius: 8px;
          transition: background-color 0.3s;
          background-color: #fafafa;

          &:last-child {
            margin-bottom: 0;
          }

          &.active-row {
            background-color: #f0f8ff;
            border: 1px solid #2488ff;
            box-shadow: 0px 0px 6px 1px #c1c1c1;
          }

          .price {
            font-size: 0.9rem;
            font-weight: 600;
          }

          .duration {
            font-size: 0.7rem;
            color: $text-muted;
          }
        }

        .pricing-column {
          display: flex;
          align-items: center;

          .el-radio__label {
            color: #2488ff;
            font-weight: 600;
          }
        }
      }

      .full-width-btn {
        width: 100%;
        margin: 15px auto 0;
        background-color: #2488ff;
        color: white;
        font-weight: bold;
      }

      .agreement-checkbox {
        display: flex;
        align-items: center;
        margin-top: 4px;

        .el-checkbox {
          font-weight: 500;
          // position: relative;
          // bottom: 2px;

          .is-checked .el-checkbox__inner {
            background-color: #2488ff;
            border-color: #2488ff;
          }
        }

        p {
          font-size: 10px;
          // margin: 7px 0 0 7px;
          color: #000;
          font-weight: 500;
          margin-left: 7px;
        }

        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #000;
        }
      }
    }
  }

  .special-card {
    .el-checkbox__input.is-disabled + span.el-checkbox__label {
      color: #606164;
      cursor: not-allowed;
    }

    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      background-color: #7575af;
      border-color: #7575af;
    }
  }

  .daily-pass-dialog {
    .el-dialog {
      width: 450px;
      margin-top: 50px !important;
    }
  }

  .el-button {
    background: #2e318d;
    color: #ffff;
    border: none;
  }

  .el-button:hover {
    background-color: #474bb8;
  }

  .yellow {
    i.el-icon-star-on,
    i.el-icon-success {
      font-size: 1.5rem;
      color: #fdda0d;
    }

    .el-button {
      background: #fdda0d;
      color: #000;
    }

    .el-button:hover {
      background-color: #f5d93c;
    }
  }

  .blue {
    i.el-icon-star-on,
    i.el-icon-success {
      font-size: 1.5rem;
      color: #2e318d;
    }

    .el-button {
      background: #2e318d;
      color: #ffff;
    }

    .el-button:hover {
      background-color: #474bb8;
    }

    i.el-icon-error {
      font-size: 1.5rem;
      color: #2e318d;
    }
  }

  .unsubscribe-plan-notification-dialog {
    .el-dialog {
      border-radius: 10px;
    }
  }

  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }

  @media screen and (max-width: 900px) {
    .unsubscribe-plan-notification-dialog .el-dialog {
      width: 90%;
    }
  }
}

.retail-side-pricing {
  @media screen and (max-width: 620px) {
    .chat-details-card {
      .el-card {
        width: 95%;
      }

      .el-card__body {
        padding: 30px;
      }
    }
  }

  @media screen and (max-width: 400px) {
    .chat-details-card {
      .el-card__body {
        padding: 15px;
      }
    }
  }
}
</style>
